import { AxiosPromise } from 'axios';

import { axios } from 'src/app/utils';
import { urlsConfig } from 'src/configs';
import { serviceLocals } from 'src/locals';
import { queryTypes, serviceActionTypes, serviceFieldsTypes, serviceInjectionTypes, serviceLogsTypes } from 'src/types';
import { fileHelper, urlHelper } from '../helpers';

export const lookupLogs = ({
  limit,
  offset,
  ids,
  fieldIds,
  eventIdsArray,
  userIdsArray,
  fieldsIdsArray,
  timestampRange,
  sortBy,
  areNullEventsIncluded = false,
  value,
  order,
  sortOrder,
  blockSpinner,
  load,
}: serviceLogsTypes.LogsLookupDataType): AxiosPromise<serviceLogsTypes.LogsLookupResultType> => {
  const query: queryTypes.LookupQueryParametersType = {};

  if (ids) {
    query.ids = ids.join(',');
  }

  if (limit) {
    query.limit = limit;
  }

  if (offset) {
    query.offset = offset;
  }

  if (value) {
    return axios.get(urlHelper.addQueryParameters({ search: value }, urlsConfig.logs.lookupLogs), {
      blockSpinner,
    });
  }

  if (eventIdsArray) {
    const queryParams: {
      eventIdsArray: string;
      areNullEventsIncluded?: string;
      limit: string | undefined;
      offset: string | undefined;
      userIdsArray?: string;
      fieldsIdsArray?: string;
      timestampRange?: string;
      sortBy?: string;
      sortOrder?: string;
    } = {
      eventIdsArray: eventIdsArray.join(','),
      limit,
      offset,
    };

    if (userIdsArray && userIdsArray.length > 0) {
      queryParams.userIdsArray = userIdsArray.join(',');
    }

    if (fieldsIdsArray && fieldsIdsArray.length > 0) {
      queryParams.fieldsIdsArray = fieldsIdsArray.join(',');
    }

    if (timestampRange && timestampRange.length > 0) {
      queryParams.timestampRange = timestampRange.join(',');
    }

    if (sortBy && sortOrder) {
      queryParams.sortBy = sortBy;
      queryParams.sortOrder = sortOrder;
    }

    queryParams.areNullEventsIncluded = areNullEventsIncluded.toString();

    return axios.get(urlHelper.addQueryParameters(queryParams, urlsConfig.logs.lookupLogs), {
      blockSpinner,
    });
  }

  if (fieldIds) {
    return axios.get(urlHelper.addQueryParameters({ fieldIds: fieldIds.join(',') }, urlsConfig.logs.lookupLogs), {
      blockSpinner,
    });
  }

  return axios.get(urlHelper.addQueryParameters(query, urlsConfig.logs.lookupLogs), {
    blockSpinner,
  });
};
